export default function Solution() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'AI-Powered Automation',
      description: 'Generate estimates and invoices in seconds, not hours',
      gradient: 'from-[#ff6b35] to-[#ff8c61]'
    },
    {
      icon: 'ri-puzzle-line',
      title: 'Trade-Specific Setup',
      description: 'Pre-configured for your exact trade with relevant fields and terminology',
      gradient: 'from-[#ff6b35] to-[#ff8c61]'
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Built-In Guidance',
      description: 'Access reliable info on pricing, workflows, and common mistakes—adjusted for your trade and experience',
      gradient: 'from-[#ff6b35] to-[#ff8c61]'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Scales With You',
      description: 'From first job to full team, the platform grows as your business does',
      gradient: 'from-[#ff6b35] to-[#ff8c61]'
    }
  ];

  return (
    <section className="bg-gray-50 py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column */}
          <div className="space-y-8">
            <span className="inline-block px-4 py-2 bg-green-100 text-green-700 rounded-full text-xs font-semibold uppercase tracking-wider">
              Our Approach
            </span>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              One platform that actually understands your trade
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Whether you're a solo pressure washer or running a 5-person electrical crew, our AI adapts to your specific trade, experience level, and business size. No generic templates. No tech jargon.
            </p>
            
            <button className="px-8 py-3 border-2 border-[#1a2332] text-[#1a2332] rounded-full font-semibold hover:bg-[#1a2332] hover:text-white transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
              See How It Works
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Right Column - Feature Cards */}
          <div className="space-y-4">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${feature.gradient} flex items-center justify-center flex-shrink-0`}>
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
